var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwittX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.357738 0.914062L4.2352 7.07408L0.333252 12.0824H1.21142L4.62758 7.69755L7.38773 12.0824H10.3762L6.28056 5.57593L9.91247 0.914062H9.0343L5.88819 4.95246L3.34619 0.914062H0.357738ZM1.64916 1.68263H3.02206L9.08457 11.3137H7.71167L1.64916 1.68263Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.334884
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwittX);
export default __webpack_public_path__ + "static/media/twitt-X.40db8879fe135aa231bfe58460e0a776.svg";
export { ForwardRef as ReactComponent };